export default "__VITE_ASSET__CF2bnoPT__"